import { useCallback, useEffect, useState } from "react";
import {
  getSelectedPractices,
  getSelectedPracticesWithName,
} from "../../../util/practices-selected.util";
import { getSelectedClient } from "../../../util/client-selected.util";
import moment from "moment";
import usePracticesByClientSelected from "../../Connections/components/PracticesByClientSelected/hooks/usePracticesByClientSelected";
import {
  getRecords,
  handleDownloadExcelGridData,
} from "../../AllTransactions/services";
import { useDebounce } from "../../../../hooks/useDebounce";
import {
  verifyFiles,
  verifyTransaction,
} from "../../../../services/missingCode";
import { displayModalConfirmation } from "../../../../util/displayMessage";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useAllTransactionsFilterNew } from "../../AllTransactions/components/AllTransactionsFilter/hooks";
import { manageDownloadDocument } from "../../../../util/download-file";

const DEFAULT_VALUE_PRACTICE_SELECTED = "All Practices";
const _setDateFilters = (filters) => {
  return {
    currentDate: filters.startDate ? new Date(filters.startDate) : new Date(),
    dateRange:
      filters.startDate && filters.endDate && filters.hasFilter
        ? {
            startDate: new Date(filters.startDate),
            endDate: new Date(filters.endDate),
          }
        : {},
  };
};

export const useExceptions = (
  permissions,
  selectedPractices,
  callFromFooter = false,
) => {
  const [filters, _setFilters] = useAllTransactionsFilterNew();
  const [dateFilters, setDateFilters] = useState(_setDateFilters(filters));
  const [transactions, setTransactions] = useState([]);
  const [currentDate, setCurrentDate] = useState(moment(filters.startDate));
  const [practiceSelected, setPracticeSelected] = useState(
    DEFAULT_VALUE_PRACTICE_SELECTED,
  );
  const [statusSelected, setStatusSelected] = useState("All Status");
  const [popoverState, setPopoverState] = useState({
    anchorEl: null,
    type: null, //'practices' o 'status'
  });
  const [isUpdatedFilters, setIsUpdatedFilters] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalItems, setTotalItems] = useState(0);
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [showFileModal, setShowFileModal] = useState(false);
  const [filterOperation, setFilterOperation] = useState([]);
  const { togglePracticeModal } = usePracticesByClientSelected();
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [isDownloadingFile, setIsDownloadingFile] = useState(false);
  const [showModalExport, setShowModalExport] = useState(false);
  const practices =
    JSON.parse(localStorage.getItem("appSettings")).practices || [];
  const [files, setFiles] = useState(null);
  const location = useLocation();

  const practicesSelected = getSelectedPractices();

  const clientSelected = getSelectedClient(practicesSelected);
  const practiceSelectedLabel = `${practicesSelected?.length || 0} ${
    practicesSelected?.length > 1 ? "practices" : "practice"
  } selected`;

  const practicesListWithName = getSelectedPracticesWithName(
    clientSelected?.clientId,
  );

  const _permissions = {
    missing_code: {
      edit_missingcode: false,
    },
    ...permissions,
  };

  const open = Boolean(popoverState.anchorEl);
  const isPracticesOpen = open && popoverState.type === "practices";
  const isStatusOpen = open && popoverState.type === "status";
  const filtersFromStorage = JSON.parse(localStorage.getItem("filters"));

  useEffect(() => {
    if (
      practicesSelected.length > 0 &&
      (location.pathname === "/allTransaction" ||
        location.pathname === "/exceptions") &&
      !callFromFooter
    )
      getAllTransactions();
  }, [
    currentPage,
    pageSize,
    practiceSelected,
    debouncedSearch,
    currentDate,
    filters,
  ]);

  const setFilters = useCallback(
    (f) => {
      //setShowAnalytics(false);
      const { form, range = false, ...rest } = f;
      if (form) {
        setDateFilters({
          ...dateFilters,
          currentDate: f.startDate || new Date(),
          dateRange: {
            startDate: f.startDate,
            endDate: f.endDate,
          },
        });
      }
      if (!range) {
        setDateFilters({
          ...dateFilters,
          currentDate: f.startDate || new Date(),
          dateRange: {},
        });
      }
      setIsUpdatedFilters(true);
      setCurrentPage(1);
      setCurrentDate(moment(f.startDate));

      _setFilters({
        ...rest,
      });
    },
    [filters],
  );

  async function getAllTransactions() {
    const params = getQueryParams();

    await getRecords(
      {
        ...params,
        ...filters,
        filter: {
          ...filters.filter,
          ivProcessResult: {
            operation: "nc",
            value: "Done",
          },
        },
        sortOptions: {
          practiceName: 1,
          dateToOrder: 1,
        },
        practiceId: getPracticesFromPracticesSelected(),
        limit: pageSize,
        offset: isUpdatedFilters ? 0 : (currentPage - 1) * pageSize,
      },
      25,
    ).then(([isSuccess, response]) => {
      if (!isSuccess) {
        toast.error("Error fetching transactions");
        console.log("Error fetching transactions:", response);
        return;
      }

      setTotalItems(response.recordsQty);
      setTransactions(response.records);
      setIsUpdatedFilters(false);
    });
  }

  function getPracticesFromPracticesSelected() {
    return practiceSelected !== DEFAULT_VALUE_PRACTICE_SELECTED
      ? practicesListWithName.practices
          .filter((practice) => practice.name === practiceSelected)
          .map((item) => item._id)
      : practicesSelected;
  }

  const getQueryParams = () => {
    return {
      endDate: currentDate.format("MM/DD/YYYY"),
      form: false,
      hasFilter: false,
      practiceId: getPracticesFromPracticesSelected(),
      range: false,
      startDate: currentDate.format("MM/DD/YYYY"),
      type: [],
    };
  };

  const handleClick = (event, type) => {
    setPopoverState({
      anchorEl: event.currentTarget,
      type,
    });
  };

  const handleClose = () => {
    setPopoverState({
      anchorEl: null,
      type: null,
    });
  };

  function changeCurrentDate(action) {
    switch (action) {
      case "next":
        setCurrentDate((prevDate) => moment(prevDate).add(1, "day"));
        setFilters({
          ...filters,
          startDate: moment(currentDate).add(1, "day").toDate(),
          endDate: moment(currentDate).add(1, "day").toDate(),
        });
        break;
      case "previous":
        setCurrentDate((prevDate) => moment(prevDate).subtract(1, "day"));
        setFilters({
          ...filters,
          startDate: moment(currentDate).subtract(1, "day").toDate(),
          endDate: moment(currentDate).subtract(1, "day").toDate(),
        });
        break;
      default:
        setCurrentDate(moment());
        break;
    }
  }

  function changePracticeSelected(practice) {
    setPracticeSelected(practice);
    setCurrentPage(1);
  }

  function changeStatusSelected(status) {
    setStatusSelected(status);
  }

  function handleChangeShowFilesModal(value) {
    setShowFileModal(value);
  }

  async function handleVerify(id, practice) {
    const [status, _res] = await verifyFiles(id, practice);
    if (status) {
      setFiles(id);
      setShowFileModal(true);
    }
  }

  async function handleUnauditRecord(rowData) {
    const nextState = !rowData.audited;
    const actionLabel = nextState ? "verified" : "not verified";

    displayModalConfirmation(
      "Verify",
      `Dear user, are you sure you want to set this record as ${actionLabel}`,
      () => {
        const { practiceId: practice, ...data } = rowData;
        verifyTransaction(data, practice, nextState).then(([status, _r]) => {
          if (!status) {
            return;
          }
          getAllTransactions();
          toast.success(`The transaction was set as ${actionLabel}`);
        });
      },
    );
  }

  async function downloadGridData() {
    setIsDownloadingFile(true);
    const request = {
      ...filters,
      practiceId: selectedPractices,
      startDate: moment(filters.startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
      endDate: moment(filters.endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
      filter: {
        ...filters.filter,
        ivProcessResult: {
          operation: "nc",
          value: "Done",
        },
      },
      sortOptions: {
        practiceName: 1,
        dateToOrder: 1,
      },
    };

    await handleDownloadExcelGridData({
      ...request,
      filter: cleanObject(request.filter),
    })
      .then((response) => {
        downloadFile(response);
        setTimeout(() => {
          setIsDownloadingFile(false);
          setShowModalExport(false);
        }, 1000);
      })
      .catch(() => {
        showErrorAndHideLoadingFile();
      });
  }

  function cleanObject(obj) {
    const cleanedEntries = Object.entries(obj).filter(
      ([_, v]) => v.operation.trim() !== "" || v.value.trim() !== "",
    );

    return cleanedEntries.length > 0 ? Object.fromEntries(cleanedEntries) : {};
  }

  const showErrorAndHideLoadingFile = () => {
    toast.error("error downloading the file, try again");
    setIsDownloadingFile(false);
  };

  function downloadFile(response) {
    const practice =
      selectedPractices.length > 0
        ? practices.find((practice) => practice._id === selectedPractices[0])
        : "";

    manageDownloadDocument(
      `${practice.client[0].name || ""} - ${moment().format(
        "DD-MM-YYYY HH:mm:ss",
      )}`,
      response,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    );
  }

  return {
    currentDate,
    changeCurrentDate,
    practiceSelectedLabel,
    clientSelected,
    practiceSelected,
    statusSelected,
    practicesListWithName,
    changePracticeSelected,
    handleClick,
    handleClose,
    open,
    isPracticesOpen,
    isStatusOpen,
    popoverState,
    changeStatusSelected,
    togglePracticeModal,
    searchQuery,
    setSearchQuery,
    practicesSelected,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    transactions,
    handleChangeShowFilesModal,
    handleVerify,
    files,
    setFiles,
    setShowFileModal,
    showFileModal,
    _permissions,
    handleUnauditRecord,
    getAllTransactions,
    filterOperation,
    filters,
    setFilterOperation,
    setFilters,
    showModalExport,
    setShowModalExport,
    isDownloadingFile,
    downloadGridData,
    showAnalytics,
    setShowAnalytics,
  };
};
